import { __awaiter, __generator } from "tslib";
import { getHashOrNull, getEmail, getEventName } from '../../utils';
import { logger } from '../../../logger';
import { version } from '../../constants';
/**@description Trigger `identify()` and `track()` `onSubmit` if a HTML form has an email field.
 * @param fields An array of key/values pairs, with an interface of fieldName: fieldValue
 * @param scriptId The `id` of the script which will be included in `track()`
 */
var handleSubmit = function (analytics, form, identifyOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var options, email, id, eventName;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                options = identifyOptions.html;
                email = getEmail(form.elements);
                if (!email) {
                    logger.debugError("HTMLPlugin: Unable to find any email in the form.");
                    return [2 /*return*/];
                }
                return [4 /*yield*/, getHashOrNull(identifyOptions.shouldHash || false, email)];
            case 1:
                id = _a.sent();
                return [4 /*yield*/, analytics.identify(id, { email: email })];
            case 2:
                _a.sent();
                logger.debug("HTMLPlugin: Identifying user", { id: id, email: email });
                eventName = getEventName(form, options);
                return [4 /*yield*/, analytics.track(eventName, { version: version })];
            case 3:
                _a.sent();
                logger.debug("HTMLPlugin: Tracked form submission", { eventName: eventName });
                return [2 /*return*/];
        }
    });
}); };
export default (function (analytics, options) {
    document.querySelectorAll('form').forEach(function (form) {
        logger.debug("HTMLPlugin: Attaching to form '".concat(form.id, "'"));
        form.setAttribute('dd-html', 'true');
        form.addEventListener('submit', function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handleSubmit(analytics, form, options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    });
});
//# sourceMappingURL=index.js.map